// NOTE: Components
import ProductList from "../../components/product/ProductList"

const Product = () => {
    return (
        <div className="py-2">
            <ProductList />
        </div>
    )
}

export default Product